import { Search, X } from "lucide-react";
import type { KeyboardEvent } from "react";
import { useTranslation } from "react-i18next";

import { Input } from "@/components/ui/input";

interface ModuleSearchProps {
  value: string;
  onChange: (value: string) => void;
  /** Placeholder and accessible name. Defaults to "Search modules". */
  placeholder?: string;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
}

/** Filter box for the expanded sidebar's module list. */
export const ModuleSearch = ({
  value,
  onChange,
  placeholder,
  onKeyDown,
}: ModuleSearchProps) => {
  const { t } = useTranslation("common");
  const label = placeholder ?? t("spaces.search_modules");

  return (
    <div className="shrink-0 px-2 lg:px-3 pt-1 pb-0">
      <div className="relative">
        <Search className="pointer-events-none absolute start-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <Input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder={label}
          aria-label={label}
          className="h-9 ps-8 pe-8 text-xs"
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange("")}
            aria-label={t("spaces.clear_search")}
            className="absolute end-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};
